import { Dig } from './dig.model';

export class Country {
  id!: number;
  dig_id!: number;
  name!: string;

  dig?: Dig;

  constructor(data: unknown = {}) {
    Object.assign(this, data);
  }
}
